// 2) Third-party library imports
import { createAction } from '@reduxjs/toolkit';

// 3d) Utility functions / interfaces
import { ResponseModalObject } from '../../utils/commonInterfaces';

const actionPrefix = 'dataRecovery';

export const recoverDataRequestAction = createAction(
    `${actionPrefix}/recoverDataRequestAction`,
    function prepare(
        payload: any,
        callback?: (response: ResponseModalObject) => void
    ) {
        return {
            payload: {
                payload,
                callback
            }
        };
    }
);

export const getBackupPerHourAction = createAction(
    `${actionPrefix}/getBackupPerHourAction`,
    function prepare(
        payload: any,
        callback?: (response: ResponseModalObject) => void
    ) {
        return {
            payload: {
                payload,
                callback
            }
        };
    }
);